import { render, staticRenderFns } from "./TahsilatlarDataTable.vue?vue&type=template&id=57992d41&scoped=true"
import script from "./TahsilatlarDataTable.vue?vue&type=script&lang=ts"
export * from "./TahsilatlarDataTable.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatlarDataTable.vue?vue&type=style&index=0&id=57992d41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57992d41",
  null
  
)

export default component.exports